module.exports = __webpack_public_path__ + "static/media/3-3.08275f28.mp3";